import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14432520"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%","height":"calc(100vh - 246px)","min-height":"300px"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 批量停用 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 批量启用 ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mas-table-opt-button" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"display":"flex","justify-content":"flex-end","padding-right":"20px"} }

import { computed, reactive, getCurrentInstance, ref, onMounted } from "vue";
import ShopInfoAndOpt from "../shopInfoAndOpt/index.vue";
import BatchImport from "../batchImport/index.vue";
import { IStaffInfo, IStoreForm } from "../interface";
import { ElMessage, ElMessageBox } from 'element-plus';
import { SimpleItem } from '@velites/common';

export default /*#__PURE__*/_defineComponent({
  props: {
  curUser: {
    type: Object,
  },
  terminal: {
    type: String,
    default: "",
  },
  visionLevel: {
    type: String,
    default: "",
  },
  shopManageCreateBtnPerm: {
    type: String || null,
    default: null,
  },
  shopManageEditBtnPerm: {
    type: String || null,
    default: null,
  },
  shopManageImportBtnPerm: {
    type: String || null,
    default: null,
  },
  importDownloadBtnPerm: {
    type: String || null,
    default: null,
  },
  importUploadBtnPerm: {
    type: String || null,
    default: null,
  },
},
  setup(__props) {

const props = __props

const { proxy } = getCurrentInstance() as any;
const storeInfoAndOptRef = ref<any>(null);
const batchImportRef = ref<any>(null);



const bigRegionList = computed(() => {
  state.form.region = "";
  return [{ label: "全部", value: "" }].concat(state.regions.filter((item: any) => item.extra.parent === state.form.saleModel || !state.form.saleModel));
})

const villageList = computed(() => {
  state.form.village = "";
  return [{ label: "全部", value: "" }].concat(state.villages.filter((item: any) => item.extra.parent === state.form.region || (!state.form.region && bigRegionList.value.map(item => item.value).includes(item.extra.parent))));
})

const state = reactive({
  form: {
    key: "",
    saleModel: "",
    region: "",
    village: "",
    shop: ""
  },
  paginationInfo: {
    total: 0,
    pageSize: 10,
    current: 1,
  },
  listData: [],
  ids: [] as string[],
  storeRoleList: [],
  showTransferDialog: false,
  userMessage: {},
  regions: [] as Array<SimpleItem>,
  villages: [] as Array<SimpleItem>,
  saleModels: [] as Array<SimpleItem>,
});
onMounted(() => {
  onSearch(1);
});
const onSearch = async (current?: number) => {
  if (current) state.paginationInfo.current = current;
  const requestObj = {
    ...state.form,
    ...state.paginationInfo,
    key: (state.form.key || '').trim()
  };
  const apis = {
    ops: "/ops/shop/list",
    mgr: "/mgr/shop/list",
  };
  const [res] = await proxy.$api.post(apis[props.terminal], requestObj);
  state.listData = res.content || [];
  state.paginationInfo.total = res.totalElements || 0;
  state.paginationInfo.current = res.number + 1;
};



const selectionChange = (data: Array<any>) => {
  state.ids = data.map(item => item.id);
}

const sizeChange = (size: number) => {
  state.paginationInfo.pageSize = size;
  onSearch(1);
};
const batchOpen = () => {
  batshChangeStatus(false);
}

const batchClose = () => {
  batshChangeStatus(true);
}

const batshChangeStatus = async (disabled: boolean) => {
  if (state.ids.length === 0) {
    ElMessage.error("请选择至少一个门店");
    return;
  }
  ElMessageBox.confirm(`确定要${disabled ? '禁用' : '启用'}选中的门店吗？`, "警告", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  }).then(async () => {
    const requestObj = {
      shopIds: state.ids,
      disabled: disabled,
    };
    const api = "/mgr/shop/batchSave";
    await proxy.$api.post(api, requestObj);
    onSearch();
    ElMessage({
      type: 'success',
      message: '操作成功'
    })
  });
}

const optionUploadExcelSuccess = () => {
  // 操作成功
  onSearch(1);
};
const addStore = () => {
  const form: IStoreForm = {
    shopId: "",
    shopName: "",
    wDepartmentId: "",
    shopCode: "",
    disabled: false,
    ...state.form,
    ...state.paginationInfo,
  };
  openModal("新建门店", "add", form);
};
const storeDeatil = (item: any) => {
  const form: IStoreForm = {
    shopId: item.id,
    shopName: item.shopName,
    shopCode: item.shopCode,
    wDepartmentId: item.wDepartmentId,
    disabled: item.disabled,
    state: item.state,
    village: item.village,
    region: item.region,
    saleModel: item.saleModel,
    ...state.form,
    ...state.paginationInfo,
  };
  openModal("查看门店", "detail", form);
};

const storeEdit = (item: any) => {
  const form: IStoreForm = {
    id: item.id,
    shopName: item.shopName,
    shopCode: item.shopCode,
    disabled: item.disabled,
    wDepartmentId: item.wDepartmentId,
    version: item.version,
    externalId: item.externalId,
    state: item.state,
    village: item.village,
    region: item.region,
    saleModel: item.saleModel,
    testDriveEVisa: item.testDriveEVisa,
    sealId: item.sealId,
    companyAccount: item.companyAccount,
    number: item.number,
    ...state.form,
    ...state.paginationInfo,
  };
  openModal("编辑门店", "edit", form);
};

const storeOpen = (item: any) => {
  const form: IStoreForm = {
    id: item.id,
    shopName: item.shopName,
    shopCode: item.shopCode,
    disabled: item.disabled,
    wDepartmentId: item.wDepartmentId,
    version: item.version,
    externalId: item.externalId,
    state: item.state,
    number: item.number,
    village: item.village,
    region: item.region,
    saleModel: item.saleModel,
    ...state.form,
    ...state.paginationInfo,
  };
  openModal("开通门店", "open", form);
};

const optionSuccess = (data: any) => {
  // 操作成功
  state.listData = data.content || [];
  state.paginationInfo.total = data.totalElements || 0;
  state.paginationInfo.current = data.number + 1;
};

const openModal = (title: string, mode: string, form: any) => {
  // 启动弹层
  const info = {
    title,
    mode,
    form,
  };
  storeInfoAndOptRef.value.active(info);
};
const openOrClose = async (item: any) => {
  let requestObj = {
    id: item.id,
    shopName: item.shopName,
    shopCode: item.shopCode,
    wDepartmentId: item.wDepartmentId,
    disabled: item.disabled ? false : true,
    version: item.version,
    ...state.form,
    ...state.paginationInfo,
  };
  const apis = {
    ops: "/ops/shop/edit",
    mgr: "/mgr/shop/edit",
  };
  const [res] = await proxy.$api.post(apis[props.terminal], requestObj);
  proxy.$Message({
    type: "success",
    message: "操作成功",
  });
  state.listData = res.content || [];
  state.paginationInfo.total = res.totalElements || 0;
  state.paginationInfo.current = res.number + 1;
};
const editGray = async (item: any) => {
  let requestObj = {
    id: item.id,

    enableGray: item.enableGray ? false : true,
  };
  const [res] = await proxy.$api.post("/mgr/shop/editGray", requestObj);
  proxy.$Message({
    type: "success",
    message: "操作成功",
  });
  item.enableGray = res.enableGray;
}
const batchImport = () => {
  batchImportRef.value.active();
};
const reset = () => {
  state.form = {
    key: "",
    saleModel: "",
    region: "",
    village: "",
    shop: ""
  };
  onSearch(1);
}
const confimForm = (res: any) => {
  onSearch(state.paginationInfo.current);
};
onSearch().then(() => {
  state.regions = proxy.pocket("regions");
  state.villages = proxy.pocket("villages");
  state.saleModels = [{ value: '', label: '全部' }].concat(proxy.pocket("saleModel"));
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_Wapper = _resolveComponent("Wapper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_mass_tool = _resolveComponent("mass-tool")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_wapper = _resolveComponent("wapper")!
  const _directive_perm = _resolveDirective("perm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Wapper, null, {
      default: _withCtx(() => [
        _createVNode(_component_mas_form_main, {
          form: _unref(state).form,
          defaultFormFooterConfirmText: "搜索",
          defaultFormFooterButton: ['confirm', 'reset'],
          onConfim: confimForm,
          onReset: reset,
          inline: true
        }, {
          content: _withCtx((slotProps) => [
            _createVNode(_component_el_form_item, {
              label: "门店所属",
              prop: "shopIds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: slotProps.content.saleModel,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.saleModel) = $event),
                  size: "normal",
                  style: {"width":"150px","margin-right":"10px"},
                  placeholder: "全部"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).saleModels, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: slotProps.content.region,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.region) = $event),
                  placeholder: "全部大区",
                  size: "normal",
                  style: {"width":"150px","margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(bigRegionList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(_component_el_select, {
                  modelValue: slotProps.content.village,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.village) = $event),
                  placeholder: "全部小区",
                  size: "normal",
                  style: {"width":"150px","margin-right":"10px"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(villageList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            (__props.terminal === 'ops')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "租户",
                  prop: "tenantId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: slotProps.content.tenantId,
                      "onUpdate:modelValue": ($event: any) => ((slotProps.content.tenantId) = $event),
                      placeholder: "请选择租户"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pocket('TenantAll'), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "搜索门店",
              prop: "key"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: slotProps.content.key,
                  "onUpdate:modelValue": ($event: any) => ((slotProps.content.key) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _: 1
    }),
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_mass_tool, {
            ids: _unref(state).ids
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                onClick: batchClose
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })), [
                [_directive_perm, __props.shopManageCreateBtnPerm]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                onClick: batchOpen
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })), [
                [_directive_perm, __props.shopManageImportBtnPerm]
              ])
            ]),
            _: 1
          }, 8, ["ids"]),
          _createVNode(_component_el_table, {
            data: _unref(state).listData,
            onSelectionChange: selectionChange,
            height: "calc(100% - 80px)"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                "min-width": "55",
                fixed: "left"
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                "show-overflow-tooltip": "",
                label: "门店名称",
                "min-width": "150"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: "pointer color-2d75d4",
                    onClick: ($event: any) => (storeDeatil(scope.row))
                  }, _toDisplayString(scope.row.shopName ? scope.row.shopName : "-"), 9, _hoisted_4)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "shopCode",
                "show-overflow-tooltip": "",
                label: "门店代码",
                "min-width": "120"
              }),
              _createVNode(_component_el_table_column, {
                label: "大区/小区",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.pocketLabel('saleModel', scope.row.saleModel) || "-") + " / " + _toDisplayString(_ctx.pocketLabel('regions', scope.row.region)
              || "-") + " / " + _toDisplayString(_ctx.pocketLabel('villages', scope.row.village) || "-"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "status",
                label: "状态",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.state == "EFFECTIVE" ? "启用" : scope.row.state == "DISABLED" ? "停用" : "未开通"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "enableGray",
                label: "SIP SDK",
                "min-width": "100"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", null, _toDisplayString(scope.row.enableGray ? "开启" : "关闭"), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                fixed: "right",
                label: "操作"
              }, {
                default: _withCtx((scope) => [
                  _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (scope.row.state != 'NOT_OPENED')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: ($event: any) => (storeEdit(scope.row))
                        }, "编辑", 8, _hoisted_6))
                      : _createCommentVNode("", true),
                    (scope.row.state == 'NOT_OPENED')
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: ($event: any) => (storeOpen(scope.row))
                        }, "开通", 8, _hoisted_7))
                      : _createCommentVNode("", true),
                    (scope.row.state != 'NOT_OPENED')
                      ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                          key: 2,
                          "confirm-button-text": "是",
                          "cancel-button-text": "否",
                          "icon-color": "red",
                          "popper-class": "hbb-work-fff",
                          title: `此操作将${scope.row.disabled ? '启用' : '停用'}账号，是否继续?`,
                          onConfirm: ($event: any) => (openOrClose(scope.row))
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(scope.row.disabled ? "启用" : "停用"), 1)
                          ]),
                          _: 2
                        }, 1032, ["title", "onConfirm"]))
                      : _createCommentVNode("", true),
                    (scope.row.state != 'NOT_OPENED')
                      ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                          key: 3,
                          "confirm-button-text": "是",
                          "cancel-button-text": "否",
                          "icon-color": "red",
                          "popper-class": "hbb-work-fff",
                          title: `此操作将${scope.row.enableGray ? '关闭' : '开启'}SIP SDK，是否继续?`,
                          onConfirm: ($event: any) => (editGray(scope.row))
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(scope.row.enableGray ? "关闭SIP" : "开启SIP"), 1)
                          ]),
                          _: 2
                        }, 1032, ["title", "onConfirm"]))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_perm, __props.shopManageEditBtnPerm]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_el_pagination, {
              "current-page": _unref(state).paginationInfo.current,
              "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).paginationInfo.current) = $event)),
              "page-size": _unref(state).paginationInfo.pageSize,
              "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).paginationInfo.pageSize) = $event)),
              small: "small",
              layout: "prev, pager, next, jumper",
              total: _unref(state).paginationInfo.total,
              onCurrentChange: onSearch
            }, null, 8, ["current-page", "page-size", "total"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(ShopInfoAndOpt, {
      onOptionSuccess: optionSuccess,
      ref_key: "storeInfoAndOptRef",
      ref: storeInfoAndOptRef,
      terminal: __props.terminal
    }, null, 8, ["terminal"]),
    _createVNode(BatchImport, {
      onOptionUploadExcelSuccess: optionUploadExcelSuccess,
      ref_key: "batchImportRef",
      ref: batchImportRef,
      terminal: __props.terminal,
      importDownloadBtnPerm: props.importDownloadBtnPerm,
      importUploadBtnPerm: props.importUploadBtnPerm
    }, null, 8, ["terminal", "importDownloadBtnPerm", "importUploadBtnPerm"])
  ], 64))
}
}

})